const MessageResultatRecherche = (props) => {
  const apiUrl = process.env.REACT_APP_API_URL;

    return (
        <div id="contacts">
        <br/>
        <ul>
      {props.searchResults.result ? (
          <>
          {props.searchResults.result && props.searchResults.result.map((item,index) => (
            <li key={index} className="contact" onClick={() => {props.recherche(item.nom,item.prenom, item.type, item.id, item.logo);props.setMessages("");}}>
              <div className="wrap">
                <img src={item.logo === '/bel.png' ? '/img/bel.png' : `${apiUrl}/image/equipe/${item.logo}` } alt="" />
                <div className="meta">
                  <p className="name">{item.nom} {item.prenom}</p>
                  <p className="preview">{item.type}</p>
                  <p className="preview">{item.email}</p>
                </div>
              </div>
            </li>
          ))}
          </>
      ):(
        <>
        {props.historique && props.historique.result.map((historique, index) => (
          <div key={index}>
            {historique.id_expediteur === props.userData.user.donnée.results[0].id && historique.type_expediteur === props.userData.user.type ? (
              <li className={props.messages[0] && props.messages[0].nom === historique.receveur_nom && props.messages[0].prenom === historique.receveur_prenom ? ("contact active") : ("contact")} key={historique.id_message} onClick={() => { props.recherche(historique.receveur_nom, historique.receveur_prenom, historique.type_receveur, historique.id_receveur, historique.logo_equipe_rec ? historique.logo_equipe_rec : '/bel.png'); props.setMessages(""); }}>                
              <div className="wrap">
                  <img src={ historique.logo_equipe_rec ? (`${apiUrl}/image/equipe/${historique.logo_equipe_rec}`):("/img/bel.png")} alt="" />
                  <div className="meta">
                    <p className="name">{historique.receveur_nom !== null && historique.receveur_prenom !== null ? (<>{historique.receveur_nom} {historique.receveur_prenom}</>):(<>Utilisateur supprimé</>)} </p>
                    <p className="preview"> Vous : {historique.message}</p>
                    <p className="preview"> {historique.date}</p>
                  </div>
                </div>
              </li>
            ):(
              <li  className={props.messages[0] && props.messages[0].nom === historique.expediteur_nom && props.messages[0].prenom === historique.expediteur_prenom ? ("contact active"):("contact ")} key={historique.id_message} onClick={() => {props.recherche(historique.expediteur_nom,historique.expediteur_nom, historique.type_expediteur,historique.id_expediteur, historique.logo_equipe_exp ? historique.logo_equipe_exp : '/bel.png');props.setMessages("");}}>
                <div className="wrap">
                  <img src={ historique.logo_equipe_exp ? (`${apiUrl}/image/equipe/${historique.logo_equipe_exp}`):("/img/bel.png")} alt="" />
                  <div className="meta">
                    <p className="name"> {historique.expediteur_nom !== null && historique.expediteur_prenom !== null ? (<>{historique.expediteur_nom} {historique.expediteur_prenom}</>):(<>Utilisateur supprimé</>)} </p>
                    <p className="preview">  {historique.message}</p>
                    <p className="preview"> {historique.date}</p>
                  </div>
                </div>
              </li>
            )}

          </div>

        ))}
        </>
      )}
      </ul>
      </div>
    )
    
    }
    
    
    
    export default MessageResultatRecherche;
    